module.exports = __webpack_public_path__ + "img/QiBao_bigPic.44f280a7.png";